import { useQuery } from '@tanstack/react-query'
import { getCurrentUser } from 'aws-amplify/auth'

import { get } from '@/services/awsAmplify'

export type RemainingVotesData = {
  id: UUID
  username: string
  remainVotes: number
}

export const remainingVotes = async (): Promise<RemainingVotesData> => {
  const { username } = await getCurrentUser()

  return get({
    path: `/remaining-votes/${username}`,
  })
}

export const useRemainingVotes = () => {
  const { data, refetch } = useQuery({
    queryKey: ['remainingVotes'],
    queryFn: remainingVotes,
  })

  return { votes: data?.remainVotes || 0, refetch }
}
